import { render, staticRenderFns } from "./PerformanceValuesReport.vue?vue&type=template&id=bc80a2a8&scoped=true&"
import script from "./PerformanceValuesReport.vue?vue&type=script&lang=js&"
export * from "./PerformanceValuesReport.vue?vue&type=script&lang=js&"
import style0 from "./PerformanceValuesReport.vue?vue&type=style&index=0&id=bc80a2a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc80a2a8",
  null
  
)

export default component.exports